/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';

const Item = ({ className, module, previewImg, errors }) => {
  return (
    <InfoItem.WithError error={errors} size="large" image={previewImg}>
      Text Block
    </InfoItem.WithError>
  );
};

export default Item;
